const firstToken = (value = "", fallback = "USER") =>
  String(value || fallback)
    .trim()
    .split(/\s+/)[0]
    .toUpperCase();

const digitSlice = (value = "", count = 5, fallback = "0") => {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits) return digits.slice(0, count);
  return fallback.repeat(count);
};

export const formatEmployeeId = (employee = {}) => {
  const name = firstToken(employee.fullName || employee.name, "EMPLOYEE");
  const mobile = digitSlice(employee.mobile || employee.phone);
  return `${name}-${mobile}`;
};

export const formatVendorId = (vendor = {}, user = {}) => {
  if (vendor.vendorCode) return String(vendor.vendorCode);
  const name = firstToken(
    vendor.companyName || user.fullName || vendor.fullName,
    "VENDOR"
  );
  const createdAt = vendor.createdAt ? new Date(vendor.createdAt) : new Date();
  const yyyy = createdAt.getFullYear();
  const mm = String(createdAt.getMonth() + 1).padStart(2, "0");
  const dd = String(createdAt.getDate()).padStart(2, "0");
  const digits = String(vendor.gstNumber || "")
    .replace(/\D/g, "")
    .slice(-4) || "0000";
  return `${name}-${yyyy}${mm}${dd}-${digits}`;
};

export const formatSupplierId = (supplier = {}, user = {}) => {
  if (supplier.supplierCode) return String(supplier.supplierCode);
  const name = firstToken(
    supplier.companyName || supplier.supplierName || user.fullName || supplier.fullName,
    "SUPPLIER"
  );
  const createdAt = supplier.createdAt ? new Date(supplier.createdAt) : new Date();
  const yyyy = createdAt.getFullYear();
  const mm = String(createdAt.getMonth() + 1).padStart(2, "0");
  const dd = String(createdAt.getDate()).padStart(2, "0");
  const digits = String(supplier.gstNumber || supplier.panNumber || "")
    .replace(/\D/g, "")
    .slice(-4) || "0000";
  return `SUP-${name}-${yyyy}${mm}${dd}-${digits}`;
};

export const formatContractorId = (contractor = {}, user = {}) => {
  const profile = contractor.profile || {};
  const name = firstToken(
    profile.contractorName || contractor.contractorName || user.fullName || contractor.fullName,
    "CONTRACTOR"
  );
  const mobile = digitSlice(
    profile.contactMobile || contractor.mobile || user.mobile,
    5
  );
  return `CON-${name}-${mobile}`;
};

export const formatUserFacingId = (record = {}, role = "") => {
  const normalizedRole = String(role || record.role || "").toLowerCase();
  if (normalizedRole === "vendor") return formatVendorId(record.profile || record, record);
  if (normalizedRole === "supplier") return formatSupplierId(record.profile || record, record);
  if (normalizedRole === "contractor") return formatContractorId(record, record);
  return formatEmployeeId(record);
};
